import { render, staticRenderFns } from "./MatterGroup.vue?vue&type=template&id=d58ca960&scoped=true"
import script from "./MatterGroup.vue?vue&type=script&lang=js"
export * from "./MatterGroup.vue?vue&type=script&lang=js"
import style0 from "./MatterGroup.vue?vue&type=style&index=0&id=d58ca960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58ca960",
  null
  
)

export default component.exports